import type { MetricObservation } from './metrics'

/** Relative first-party relay; no Datadog credential reaches the browser. */
export const BROWSER_METRIC_ENDPOINT = '/api/telemetry/metrics'
export const BROWSER_METRIC_MAX_BATCH = 32
export const BROWSER_METRIC_MAX_QUEUE = 256
export const BROWSER_METRIC_MAX_BODY_BYTES = 16_384
/** One final request leaves 16 KiB of the platform's shared 64 KiB budget. */
export const BROWSER_METRIC_EXIT_BODY_BYTES = 49_152

export type BrowserMetricPoint = MetricObservation['metric']
export type BrowserMetricBatch = {
  readonly schema_version: 1
  readonly metrics: ReadonlyArray<BrowserMetricPoint>
}
